export const HostViewTemplatesEnum = {
    HostDefaultView: 1,
    HostSelectionVoucherView: 2,
    HostDiscountVoucherView: 3,
};
